import { render, staticRenderFns } from "./menu-group.vue?vue&type=template&id=570c0eae&scoped=true"
import script from "./menu-group.vue?vue&type=script&lang=js"
export * from "./menu-group.vue?vue&type=script&lang=js"
import style0 from "./menu-group.vue?vue&type=style&index=0&id=570c0eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570c0eae",
  null
  
)

export default component.exports